import baseApi from "./baseApi"

export default  {
    /**
     * Fetch absences for a given Attendance Member
     * @return {Object} -- Alert Totals
     */
    async getAttendanceMemberAbsences(attendanceMemberID) {
        let request = await baseApi.createHttpRequest();
        let result = await request.get(`/absence/attendanceMember?attendanceMemberID=${attendanceMemberID}`);
        
        return result.data;
    },

    async saveAttendanceMemberAbsence(absenceDetail){
        let request = await baseApi.createHttpRequest();
        let result = await request.post(`/absence/save`, absenceDetail);
        console.log('api result', result)
        if(!result.data.Success) {
            throw new Error(result.data.ErrorMessages[0])
        }
        return result.data;
    },

    async deleteAttendanceMemberAbsence(absenceDetail){
        let request = await baseApi.createHttpRequest();
        let result = await request.post(`/absence/del`, absenceDetail);
        console.log('api result', result)
        if(!result.data.Success) {
            throw new Error(result.data.ErrorMessages[0])
        }
        return result.data;
    },

    async getCropWorkAttendanceMemberAbsences(attendanceMemberID) {
        let request = await baseApi.createHttpRequest();
        let result = await request.get(`/absence/attendanceMember?attendanceMemberID=${attendanceMemberID}`);
        
        return result.data;
    },

    async saveCropWorkAttendanceMemberAbsence(absenceDetail){
        let request = await baseApi.createHttpRequest();
        let result = await request.post(`/absence/save`, absenceDetail);
        console.log('api result', result)
        if(!result.data.Success) {
            throw new Error(result.data.ErrorMessages[0])
        }
        return result.data;
    },

    async deleteCropWorkAttendanceMemberAbsence(absenceDetail){
        let request = await baseApi.createHttpRequest();
        let result = await request.post(`/absence/del`, absenceDetail);
        console.log('api result', result)
        if(!result.data.Success) {
            throw new Error(result.data.ErrorMessages[0])
        }
        return result.data;
    }
}